import React, { useState, useRef } from "react";
import axios from "axios";
import { main_link } from "../Connection/Connection";

import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";

import { Toast } from "primereact/toast";

const AddBeardPriceModel = (props) => {
  const counter = props.counter;
  const setCounter = props.setCounter;
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState();
  const [price, setPrice] = useState();

  const add = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!name || !price) {
      toast.current.show({
        severity: "error",
        summary: "error",
        detail: "All Fields Are Required!!.",
      });
      setLoading(false);
      return 0;
    }
    const type = "Beard";
    const user = JSON.parse(sessionStorage.getItem("user-data"));
    const user_id = user["encrypted_id"];
    try {
      const response = await axios.post(main_link + "addBread", {
        user_id,
        name,
        price,
        type,
      });
      setLoading(false);

      if (response.data.message == "Added Successfully.") {
        document.getElementById("addBeardCut").reset();
        $("#beard-cut").modal("hide");
        setName("");
        setPrice("");
        setCounter(counter + 1);

        toast.current.show({
          severity: "success",
          summary: "success",
          detail: "Added Successfully.",
        });
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }

    setLoading(false);
  };

  return (
    <>
      <Toast ref={toast} />
      <div className="modal fade" id="beard-cut">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header bg-orange text-white">
              <h4 className="modal-title">Add Beard Cut Price</h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <Form id="addBeardCut">
                <Container>
                  <Row>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="Name.ControlInput1"
                      >
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="name"
                          placeholder="Cut Name"
                          onChange={(e) => setName(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group
                        className="mb-3"
                        controlId="Price.ControlInput1"
                      >
                        <Form.Label>Price in $</Form.Label>
                        <Form.Control
                          type="name"
                          placeholder="Price"
                          onChange={(e) => setPrice(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Container>
              </Form>
            </div>
            <div className="modal-footer justify-content-between">
              <button
                type="button"
                className="btn btn-default border-success"
                data-dismiss="modal"
              >
                Close
              </button>
              {!loading && (
                <Button type="button" className="btn btn-primary" onClick={add}>
                  Save changes
                </Button>
              )}
              {loading && (
                <Button type="button" disabled className="btn btn-primary">
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />{" "}
                  Loading...
                </Button>
              )}
            </div>
          </div>
          {/* /.modal-content */}
        </div>
        {/* /.modal-dialog */}
      </div>
    </>
  );
};

export default AddBeardPriceModel;
